<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row v-if="!searching" justify="space-between">
      <v-col cols="12" md="3">
        <h2>
          Pregled prejema in izdaje:
        </h2>
      </v-col>
    </v-row>
    <v-row v-if="!searching">
      <v-col cols="3" md="3">
        <DateSelector
          label="Od"
          :date="startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="3" md="3">
        <DateSelector
          label="Do"
          :date="endDate"
          @change="updateEndDate"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="() => search(0)"
        >
          Išči
          <v-icon right dark>fas fa-search</v-icon>
        </v-btn>
        <!-- <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>mdi-content-save-outline</v-icon>
        </v-btn> -->
        <div class="mb-2 d-md-none"></div>
      </v-col>
    </v-row>

    <v-row v-if="!searching" justify="space-between">
      <v-col cols="12" md="3">
        <h2>
          Dnevnik po artiklu<!-- Evidenca nabave in porabe po artiklu -->
        </h2>
      </v-col>
    </v-row>
    <v-row v-if="!searching">
      <v-col cols="3" md="3">
        <DateSelector
          label="Od"
          :date="startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="3" md="3">
        <DateSelector
          label="Do"
          :date="endDate"
          @change="updateEndDate"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="() => search(1)"
        >
          Išči
          <v-icon right dark>fas fa-search</v-icon>
        </v-btn>
        <!-- <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>fas fa-search</v-icon>
        </v-btn> -->
        <div class="mb-2 d-md-none"></div>
      </v-col>
    </v-row>
    <v-row v-if="!searching">
      <v-col cols="12" md="6" sm="12">
        <v-select
            id="categoriesSelect"
            class="categoriesSelecta"
            v-model="selectedCategoryIds"
            :items="categories"
            :menu-props="{ maxHeight: '400' }"
            label="Skupine"
            multiple
            hint="Izberite željene skupine ali pustite prazno za vse skupine"
            persistent-hint
            item-text="name"
            item-value="id"
            clearable
        >
          <template slot="selection" class="categoriesSelecta" slot-scope="{ item, index }">
            <span>{{ item.name }}</span>
            <span class="grey--text caption" v-if="index === 1">
              &nbsp;(+{{ selectedCategoryIds.length - 1 }} others)
            </span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row v-if="!searching">
      <v-col cols="12" md="6" sm="12">
        <v-select
            id="groupsSelect"
            v-model="selectedGroupsIds"
            :items="groups"
            :menu-props="{ maxHeight: '400' }"
            label="Grupe"
            multiple
            height="32"
            hint="Izberite željene grupe ali pustite prazno za vse grupe"
            persistent-hint
            item-text="name"
            item-value="id"
            clearable
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-row v-if="!searching && base64pdf">
      <v-col cols="12" offset="1" md="8" offset-md="2">
        <pdf class="pdf-preview" :src="`data:application/pdf;base64,${base64pdf}`"></pdf>
      </v-col>
    </v-row> -->

    <v-row v-if="searching">
      <app-spinner>Pridobivanje podatkov..</app-spinner>
    </v-row>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import printJS from 'print-js'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateSelector from '../components/DateSelector.vue'
import AppSpinner from '../components/AppSpinner.vue'
import { objectToArray } from '@/utils/object'

export default {
  props: ['id'],
  mixins: [
    asyncDataStatus
  ],
  components: {
    DateSelector,
    AppSpinner,
    pdf
  },
  data () {
    return {
      base64pdf: null,
      fileName: '',
      startDate: null,
      endDate: null,
      selectedCategoryIds: [],
      selectedGroupsIds: [],
      categories: null,
      groups: null,
      searching: false,
    }
  },
  methods: {
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    ...mapActions('groups', { loadGroups: 'loadItems' }),
    ...mapActions('companies', ['getCreateMaterialDiaryPdfReport', 'getArticleDiary', 'getCreateArticleDiaryPdfReport']),
    print () {
      printJS({ printable: this.base64pdf, type: 'pdf', base64: true })
    },
    save () {
      const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.base64pdf}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = this.fileName
      downloadLink.click()
    },
    send () {

    },
    updateStartDate ({ date }) {
      this.startDate = date
    },
    updateEndDate ({ date }) {
      this.endDate = date
    },
    search (type = 0) {
      this.searching = true
      if (type === 0) {
        this.getCreateMaterialDiaryPdfReport({ startDate: this.startDate, endDate: this.endDate })
        .then(response => {
          const responseItems = response.data.items[0]
          this.asyncDataStatus_fetched()
          this.base64pdf = responseItems.data
          this.fileName = responseItems.filename
          this.searching = false

          let routeData = this.$router.resolve({ name: 'MyCompanyMaterialDiaryPreview' })
          localStorage.setItem('parametri', JSON.stringify({ base64: this.base64pdf, fileName: this.fileName }))
          window.open(routeData.href, '_blank')
          // console.log(this.base64pdf)
        })
        .catch(anErr => {
          console.log(anErr)
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri liste prevzemnic.'
          })
        })
      } else {
        const filters = {}
        if (this.selectedCategoryIds && this.selectedCategoryIds.length && !this.selectedCategoryIds.includes(null)) {
          filters.categories = this.selectedCategoryIds.join(',')
        }
        if (this.selectedGroupsIds && this.selectedGroupsIds.length && !this.selectedGroupsIds.includes(null)) {
          filters.groups = this.selectedGroupsIds.join(',')
        }
        this.getCreateArticleDiaryPdfReport({ startDate: this.startDate, endDate: this.endDate, filters })
        .then(response => {
          const responseItems = response.data.items[0]
          this.asyncDataStatus_fetched()
          this.base64pdf = responseItems.data
          this.fileName = responseItems.filename
          this.searching = false

          let routeData = this.$router.resolve({ name: 'MyCompanyMaterialDiaryPreview' })
          localStorage.setItem('parametri', JSON.stringify({ base64: this.base64pdf, fileName: this.fileName }))
          window.open(routeData.href, '_blank')
          // console.log(this.base64pdf)
        })
        .catch(anErr => {
          console.log(anErr)
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri liste prevzemnic.'
          })
        })
      }
    },
    closeWindow () {
      window.close()
    }
  },
  created () {
    this.asyncDataStatus_fetched()
    this.startDate = moment().format('YYYY-MM-DD')
    this.endDate = moment().format('YYYY-MM-DD')
    Promise.all([this.loadCategories(), this.loadGroups()])
      .then(response => {
        this.categories = objectToArray(this.$store.state.categories.items)
        this.groups = objectToArray(this.$store.state.groups.items)
      })
    /* this.getElectronicDeviceListForDealer({ startDate: this.startDate, endDate: this.endDate })
      .then(response => {
        const responseItems = response.data.items[0]
        this.asyncDataStatus_fetched()
        this.base64pdf = responseItems.data
        this.fileName = responseItems.filename
      })
      .catch(anErr => {
        console.log(anErr)
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri liste prevzemnic.'
        })
      }) */
  }
}
</script>

<style scoped>
@media (min-width:320px) {
  ::v-deep .v-select__selections {
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
    overflow: auto;
  }
}
</style>

<style scoped>


.pdf-preview {
  position:relative;
  display: block;
  border: 1px solid black;
}

</style>


<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>